import React from "react";
import useLenis from "../hooks/useLenis";
import { LandingHeader } from "../components/landing/LandingHeader";
import { TermsModal } from "../components/landing/TermsModal";
import { HeroSection } from "../components/landing/HeroSection";
import { TrustMarquee } from "../components/landing/TrustMarquee";
import { HowItWorks } from "../components/landing/HowItWorks";
import { WhyItWorks } from "../components/landing/WhyItWorks";
import { ComparisonSection } from "../components/landing/ComparisonSection";
import { Testimonials } from "../components/landing/Testimonials";
import { FAQSection } from "../components/landing/FAQSection";
import { FinalCTA } from "../components/landing/FinalCTA";
import { LandingFooter } from "../components/landing/LandingFooter";

const scrollToForm = () =>
  document.getElementById("apply")?.scrollIntoView({ behavior: "smooth", block: "start" });

export default function Landing() {
  useLenis();

  return (
    <div className="bg-[#F6F5F2] text-[#052F24] overflow-x-hidden">
      <TermsModal />
      <LandingHeader onCheckEligibility={scrollToForm} />
      <HeroSection />
      <TrustMarquee />
      <HowItWorks />
      <WhyItWorks />
      <ComparisonSection />
      <Testimonials />
      <FAQSection />
      <FinalCTA onCheckEligibility={scrollToForm} />
      <LandingFooter />
    </div>
  );
}
